<script lang="ts">
    import { createDialog, melt } from '@melt-ui/svelte';
    import { fade } from 'svelte/transition';

    import { trans } from '$assets/shop-translator.js';
    import cn from '$common/utils/cn';
    import { flyDrawer } from '$saga/utils/customTransitions';
    import PillarFiltersDrawer from '$saga/views/Search/components/drawer/PillarFiltersDrawer/PillarFiltersDrawer.svelte';
    import {
        pillarFiltersModalOpen,
        pillarFiltersSelectedFilterType,
    } from '$saga/views/Search/store';
    import { FilterType } from '$saga/views/Search/types';

    import HomeTitle from './HomeTitle.svelte';
    import PillarFilters from './PillarFilters.svelte';
    import SearchInput from './SearchInput.svelte';
    import SearchToggler from './SearchToggler.svelte';

    export let isHybridSearchEnabled = false;
    export let homeTitle: string;

    const pillarFiltersTitles = {
        [FilterType.DESTINATION]: trans('search.bar.search_destination'),
        [FilterType.SPORT]: trans('search.bar.search_sport'),
        [FilterType.PAX]: trans('search.bar.travelers'),
        [FilterType.STARTDATE]: trans('search.bar.departure_date'),
    } as Partial<Record<FilterType, string>>;

    $: pillarFiltersMenuTitle =
        pillarFiltersTitles[$pillarFiltersSelectedFilterType] ??
        trans('search.bar.search');

    const handleSelectedFilter = (filterType: FilterType) => {
        pillarFiltersSelectedFilterType.set(filterType);
    };

    const resetView = () => {
        pillarFiltersSelectedFilterType.set(FilterType.SELECTION);
    };

    const {
        elements: { trigger, title, overlay, content, close, portalled },
        states: { open },
    } = createDialog({
        open: pillarFiltersModalOpen,
        forceVisible: true,
    });
</script>

<div
    class={cn(
        'absolute z-10 w-full px-m desktop:z-30 desktop:w-full desktop:max-w-layout-max desktop:px-5xl max-[375px]:top-[5%] top-[10%] desktop:top-[30%] desktop:left-1/2 desktop:-translate-x-1/2',
    )}
>
    <HomeTitle {homeTitle} />

    {#if isHybridSearchEnabled}
        <div class="relative">
            <SearchToggler>
                {#snippet toggleAContent()}
                    <SearchInput />
                {/snippet}

                {#snippet toggleBContent()}
                    <PillarFilters {trigger} {handleSelectedFilter} />
                {/snippet}
            </SearchToggler>
        </div>
    {:else}
        <PillarFilters {trigger} {handleSelectedFilter} />
    {/if}
</div>

{#if $open}
    <div use:melt={$portalled}>
        <div
            use:melt={$overlay}
            class="fixed inset-0 z-40 bg-black/50"
            transition:fade={{ duration: 250 }}
        ></div>
        <div
            use:melt={$content}
            class="fixed inset-x-0 bottom-0 z-50 flex h-full max-h-[calc(100%)] w-full flex-col bg-white transition-all duration-500 desktop:inset-x-[unset] desktop:right-0 desktop:top-0 desktop:min-w-[33vw] desktop:max-w-[33vw]"
            transition:flyDrawer
        >
            <PillarFiltersDrawer
                selectedFilterType={$pillarFiltersSelectedFilterType}
                {handleSelectedFilter}
                {pillarFiltersMenuTitle}
                {title}
                {close}
                {resetView}
            />
        </div>
    </div>
{/if}
